import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import TwoToneItem from "../../../shared/components/dashboard/TwoToneItem";
import { FlexContainer } from "../../../shared/components/styled/Container.styled";

const DashboardSummaryCard = ({
  Icon = <></>,
  iconColor = "inherit",
  iconSize = "medium",
  label = "",
  breakpoint = " ",
  data = "",
  prefix = "",
  valueFontSize = "1rem",
  prefixFontSize = "0.8571rem",
  hasExtraInfo = false,
  clickAction = () => {},
  cursor = "default",
  background = "transparent",
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Mobile Layout - Horizontal List Style
  if (isMobile) {
    return (
      <FlexContainer
        flexdirection="row"
        width="100%"
        padding="12px 16px"
        gap="12px"
        alignitems="center"
        justifycontent="space-between"
        borderradius="inherit"
        onClick={clickAction}
        sx={{
          cursor,
          background: {
            xs: "transparent",
            lg: `${background}`,
          },
          borderBottom: "1px solid #e0e0e0",
          "&:last-child": {
            borderBottom: "none",
          },
        }}
      >
        <FlexContainer 
          flexdirection="row" 
          alignitems="center"
          gap="12px"
          sx={{ minWidth: 0 }}
        >
          <Icon color={iconColor} sx={{ fontSize: "24px" }} />
          <Typography 
            variant="h6" 
            fontWeight="bold"
            fontSize="0.95rem"
            color="text.primary"
            noWrap
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            {label}
          </Typography>
        </FlexContainer>
        
        {data && (
          <TwoToneItem
            breakpoint={breakpoint}
            data={data}
            prefix={prefix}
            toneOne="primary"
            toneTwo="primary"
            fontSize={valueFontSize}
            prefixFontSize={prefixFontSize}
          />
        )}
        
        {hasExtraInfo && (
          <FlexContainer gap="5px" alignitems="center">
            <Typography fontSize="12px" color="text.hint">
              Learn More
            </Typography>
            <HelpOutlineOutlinedIcon fontSize="small" color="disabled" />
          </FlexContainer>
        )}
      </FlexContainer>
    );
  }

  // Desktop Layout - Original Card Style
  return (
    <FlexContainer
      flexdirection="column"
      width="100%"
      height="100%"
      padding="10px"
      background={background}
      gap="10px"
      alignitems="flex-start"
      borderradius="inherit"
      onClick={clickAction}
      sx={{ cursor }}
    >
      <Icon color={iconColor} sx={{ fontSize: iconSize }} />
      <FlexContainer width="100%" justifycontent="space-between" sx={{ minWidth: 0 }}>
        <Typography variant="h6" fontWeight="bold" noWrap sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "65%",
        }}>
          {label}
        </Typography>
        <TwoToneItem
          breakpoint={breakpoint}
          data={data}
          prefix={prefix}
          toneOne="primary"
          toneTwo="primary"
          fontSize={valueFontSize}
          prefixFontSize={prefixFontSize}
        />
      </FlexContainer>
      {hasExtraInfo ? (
        <FlexContainer width="100%" justifycontent="flex-end" gap="5px">
          <Typography fontSize="12px" color="text.hint">
            Learn More
          </Typography>
          <HelpOutlineOutlinedIcon fontSize="small" color="disabled" />
        </FlexContainer>
      ) : (
        <Box width="100%" height="18px" />
      )}
    </FlexContainer>
  );
};

export default DashboardSummaryCard;